import * as Application from 'expo-application';
import * as IntentLauncher from 'expo-intent-launcher';
import { Linking } from 'react-native';

import { IS_IOS } from './platform';

export function openAppSettings() {
  if (IS_IOS) {
    Linking.openURL('app-settings:');
  } else {
    IntentLauncher.startActivityAsync(
      IntentLauncher.ActivityAction.APPLICATION_DETAILS_SETTINGS,
      { data: 'package:' + Application.applicationId },
    );
  }
}
